import React, { useState } from "react"
import { useSecureRequest } from "../../../hooks/useSecureRequest"
import { useCompany } from "../../../contexts/CompanyContext"
import { useConfig } from "../../../contexts/ConfigContext"
import { Input, message, Space } from "antd"
import { getDateFilter } from "../../../utils"
import { useSale } from "../../../contexts/SaleContext"
import DateTimePicker from "./DateTimePicker"


const {Search} = Input

type headerElementsProps = {
  setSpinning: (spinning: boolean) => void
}

function HeaderElements({setSpinning}:Readonly<headerElementsProps>){
  const [loading,setLoading] = useState(false)
  const {company} = useCompany()
  const {config} = useConfig()
  const {sale,updateSale} = useSale()
  const {securePost} = useSecureRequest()

  const handleMovementSearch = async (text:string) => {
    setLoading(true)
    const path = text ? '/inventory/movement/search-movements' : '/inventory/movement/get-movements'
    const requestData:any = {
      company:company.current?.uid,
      search:text,
      type: "full",
      document_type: "SALE_INVOICE",
      status: "COMPLETED",
      module: config.module 
    }
    if(!text){
      requestData.filter = getDateFilter(sale.datePickerFilter)
    }
    const itemResponse = await securePost(path,requestData)
    if(itemResponse.status === 200){
      if(itemResponse.movementList.length){
        updateSale({billList:itemResponse.movementList})
      }else{
        message.error("No se encontraron resultados")
      }
    }
    setLoading(false)
  }
  return(
    <Space size="middle">
    <div style={{ display: "flex", gap: 4, alignItems: "center" }}>
      <Search
        placeholder="Buscar por término"
        allowClear
        onSearch={handleMovementSearch}
        loading={loading}
        enterButton
        style={{ maxWidth: 250 }}
      />
      <DateTimePicker setSpinning={setSpinning}/>
    </div>
  </Space>
  )
}

export default HeaderElements